import {Async, Empty} from 'Core/models/Async';
import {createAction} from 'Shared/utilities/actionCreator';

export enum SearchActionType {
  SEARCH_POLICES_BY_INSURED_NAME = 'search/SEARCH_POLICES_BY_INSURED_NAME',
  SEARCH_POLICES_BY_LAST_4_OF_SSN = 'search/SEARCH_POLICES_BY_LAST_4_OF_SSN ',
  SEARCH_POLICES_BY_LAST_4_OF_OWNER_SSN = 'search/SEARCH_POLICES_BY_LAST_4_OF_OWNER_SSN ',
  SEARCH_POLICIES_BY_PAYOR_NAME = 'search/SEARCH_POLICIES_BY_PAYOR_NAME',
  SEARCH_POLICIES_BY_POLICY_NUMBER = 'search/SEARCH_POLICIES_BY_POLICY_NUMBER',
  SEARCH_ACCOUNTS = 'search/SEARCH_ACCOUNTS',
  SEARCH_ACCOUNTS_BY_NUMBER = 'search/SEARCH_ACCOUNTS_BY_NUMBER',
  SEARCH_AGENTS = 'search/SEARCH_AGENTS',
  SEARCH_AGENTS_BY_LAST_NAME = 'search/SEARCH_AGENTS_BY_LAST_NAME',
  LOAD_RESULTS = 'search/LOAD_RESULTS',
  CLEAR = 'search/CLEAR',
  SEARCH_OPTIONS_EMPTY = 'search/SEARCH_OPTIONS_EMPTY',
}

export const clearSearch = () => createAction(SearchActionType.CLEAR);
export const searchAgents = (name: string) => createAction(SearchActionType.SEARCH_AGENTS, {name});
export const searchAgentsByLastName = (lastName: string) =>
  createAction(SearchActionType.SEARCH_AGENTS_BY_LAST_NAME, {lastName});
export const searchAccounts = (name: string) => createAction(SearchActionType.SEARCH_ACCOUNTS, {name});
export const searchAccountsByNumber = (accountNumber: string) =>
  createAction(SearchActionType.SEARCH_ACCOUNTS_BY_NUMBER, {accountNumber});
export const searchPoliciesByPolicyNumber = (policyNumber: string, isExact?: boolean) =>
  createAction(SearchActionType.SEARCH_POLICIES_BY_POLICY_NUMBER, {policyNumber, isExact});
export const searchPolicies = (insuredName: string) =>
  createAction(SearchActionType.SEARCH_POLICES_BY_INSURED_NAME, {insuredName});
export const searchPoliciesByLast4OfSSN = (ssn: string) =>
  createAction(SearchActionType.SEARCH_POLICES_BY_LAST_4_OF_SSN, {ssn});
export const searchPoliciesByLast4OfOwnerSSN = (ssn: string) =>
  createAction(SearchActionType.SEARCH_POLICES_BY_LAST_4_OF_OWNER_SSN, {ssn});
export const searchPoliciesByPayorName = (name: string) =>
  createAction(SearchActionType.SEARCH_POLICIES_BY_PAYOR_NAME, {name});
export const loadResults = (results: Async<SearchResult[]>) => createAction(SearchActionType.LOAD_RESULTS, {results});
export const updateSearchOptionsStatus = (status: boolean) => createAction(SearchActionType.SEARCH_OPTIONS_EMPTY, {status});

export type SearchResult = {
  label: string;
  value: string;
  selectRoute: any;
  viewMoreRoute: string;
};
type SearchState = {
  results: Async<SearchResult[]>;
  areSearchOptionsEmpty: boolean;
};
const DEFAULT_STATE: SearchState = {
  results: new Empty(),
  areSearchOptionsEmpty: false,
};
type SearchAction = ReturnType<typeof loadResults> | ReturnType<typeof clearSearch> | ReturnType<typeof updateSearchOptionsStatus>;

export default (state: SearchState = DEFAULT_STATE, action: SearchAction): SearchState => {
  switch (action.type) {
    case SearchActionType.CLEAR:
      return DEFAULT_STATE;
    case SearchActionType.LOAD_RESULTS:
      return {
        ...state,
        results: action.payload.results,
      };
    case SearchActionType.SEARCH_OPTIONS_EMPTY:
      return {
        ...state,
        areSearchOptionsEmpty: action.payload.status
      };
    default:
      return state;
  }
};

export const searchAccountsFilter = (
  inputValue: any,
  searchType: any,
  SearchType: any,
  setResult: React.Dispatch<React.SetStateAction<string>>,
  searchActionCreator: any,
  dispatch: React.Dispatch<any>,
  unsupportedCharacters: string[]
) => {
  if (searchActionCreator) {
    let compareChars = inputValue.split('').filter((e: any) => unsupportedCharacters.indexOf(e) !== -1);
    if (compareChars.length === 0) {
      setResult('');
      dispatch(searchActionCreator(inputValue));
    } else {
      setResult('No Results Found');
    }
  }
};
